import { FormatSmartDate } from '../dates';
import * as models from './models';

export function LoginAccountLabel(accountInit: models.IUser): string {
    const account = new models.User(accountInit);
    if (account.emailAddress.email) {
        return account.emailAddress.email;
    }
    const parts: string[] = [];
    const name = account.fullName();
    if (name) {
        parts.push(name);
    }
    if (account.company) {
        parts.push(account.company);
    }
    if (account.created.isValid) {
        parts.push(FormatSmartDate(account.created));
    }
    return parts.join(' · ');
}
